<div class="container">
  <div class="dialog-header">
    <p i18n="@@claimBusiness">Claim Business</p>
    <div (click)="closeDialog()"><img src="assets/close-icon.svg"></div>
  </div>
  <div class="claim-business-message">
    <p i18n="@@claimBusinessModalMessage">Verify and take control of your business page to start connecting with customers and managing your offerings.</p>
  </div>
  <input-text-field
    id="name"
    [validators]="[Validators.required]"
    [group]="claimBusinessForm"
    floatingLabel="{{nameLabel}}">
  </input-text-field>
  <input-text-field
    id="email"
    [validators]="[Validators.email, Validators.required]"
    [group]="claimBusinessForm"
    floatingLabel="{{emailLabel}}"
    [inputType]="InputType.email">
  </input-text-field>
  <mobile-number
    mobileNumberId="mobile"
    countryCodeId="countryCodeId"
    [validators]="[Validators.required]"
    [list]="countries"
    [floatingMobileLabel]="mobile"
    [floatingCodeLabel]="code"
    [group]="claimBusinessForm">
  </mobile-number>
  <div class="text-danger my-2" *ngIf="serverErrorMessage !== null">{{ serverErrorMessage }}</div>
  <primary-button
    class="submit-button"
    (onClick)="claim()"
    [loading]="loading"
    [enabled]="claimBusinessForm.valid"
    title="{{submit}}">
  </primary-button>
</div>
